import React, {Component} from "react";
import Group, {GroupDescription} from "../../../Components/Group";
import './index.css';
import Grid, {gridDateFilterConfig, gridDateTime, gridSetFilterConfig, gridTextFilterConfig} from "../../../Components/Grid";
import {ModalAction} from "../../../Components/Modal";
import Prompt from "../../../Components/Prompt";
import {Tool} from '../../../App';
import {connect} from 'react-redux';

class PageGridTest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            grid: {
                columnDefs: [{
                    headerName: 'اطلاعات بیمار',
                    headerTooltip: 'اطلاعات بیمار',
                    children: [{
                        field: 'patientFileCode',
                        headerName: 'شماره پرونده',
                        headerTooltip: 'شماره پرونده',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        ...gridTextFilterConfig
                    }, {
                        field: 'patientFullName',
                        headerName: 'نام بیمار',
                        headerTooltip: 'نام بیمار',
                        cellRenderer: row => row.data?.patientFirstName ? `${row.data?.patientFirstName} ${row.data?.patientLastName}` : '',
                        ...gridTextFilterConfig
                    }, {
                        field: 'patientNationalCode',
                        headerName: 'کد‌ملی',
                        headerTooltip: 'کد‌ملی',
                        ...gridTextFilterConfig
                    }, {
                        field: 'patientBloodGroupStr',
                        headerName: 'BGRh بیمار',
                        headerTooltip: 'BGRh بیمار',
                        cellRenderer: row => row.data?.patientBloodGroupStr || '',
                        cellClass: 'green',
                        ...gridSetFilterConfig(props.base?.bloodGroups?.map(item => item.name))
                    }, {
                        field: 'patientBirthDate',
                        headerName: 'تاریخ تولد بیمار',
                        headerTooltip: 'تاریخ تولد بیمار',
                        // hide: true,
                        cellRenderer: row => row.data?.patientBirthDate || '',
                        ...gridDateFilterConfig
                    }]
                }, {
                    headerName: 'اطلاعات فرآورده',
                    children: [{
                        field: 'productNumber',
                        headerName: 'شماره فرآورده',
                        headerTooltip: 'شماره فرآورده',
                        ...gridTextFilterConfig
                    }, {
                        field: 'productBloodGroupStr',
                        headerName: 'BGRH فرآورده',
                        headerTooltip: 'BGRH فرآورده',
                        cellRenderer: row => row.data?.productBloodGroupStr || '',
                        cellClass: 'green',
                        ...gridSetFilterConfig(props.base?.bloodGroups?.map(item => item.name))
                    }, {
                        field: 'productTypeStr',
                        headerName: 'نوع فرآورده',
                        headerTooltip: 'نوع فرآورده',
                        cellRenderer: row => row.data?.productTypeStr || '',
                        ...gridSetFilterConfig(props.base?.productTypes?.map(item => item.name))
                    }]
                }, {
                    headerName: 'اطلاعات تزریق',
                    headerTooltip: 'اطلاعات تزریق',
                    children: [{
                        field: 'consumptionDateTime',
                        headerName: 'زمان تزریق',
                        headerTooltip: 'زمان تزریق',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime,
                        ...gridDateFilterConfig
                    },]
                }, {
                    field: 'complicatedDateTime',
                    headerName: 'زمان ثبت',
                    headerTooltip: 'زمان ثبت',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime,
                    ...gridDateFilterConfig
                }],
                rowModelType: 'serverSide',
                pagination: true,
                paginationAutoPageSize: true,
                cacheBlockSize: 100,
                serverSideStoreType: 'partial',
                frameworkComponents: {}
            },
            incomingGrid: null
        };

        this.ref = {
            prompt: React.createRef()
        };
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid;
    }

    render() {
        return <React.Fragment>
            <Group className={'PageGridTest-group mar-10'}>
                <GroupDescription>لیست فرآورده‌های اضافه شده / ارسال شده به سازمان از این قسمت قابل مشاهده می باشد.</GroupDescription>
                <Grid id={'hemoIncoming'} {...this.state.grid} onGridReady={this.incomingGridReadyHandler.bind(this)}/>
            </Group>
            <Prompt ref={this.ref.prompt}/>
        </React.Fragment>;
    }

    updateGrid(data, success = _ => null, fail = _ => null) {
        const url = `${window.ENV.MAIN_SERVER}/api/SectionRequest/GetComplicatedProductsV2`;
        data.filterModel = JSON.stringify(data.filterModel);
        data.sortModel = JSON.stringify(data.sortModel);

        // fetch(Api.HOSPITAL.LIST.INCOMING, {
        fetch(url, {
            body: JSON.stringify(data),
            method: Tool.METHODS.POST,
            headers: Tool.headers()
        }).then(response => {
            Tool.response(response, {
                '200:0': result => {
                    success(result.objList, result.totalCount);
                },
                'default': result => {
                    fail([]);
                }
            });
        }).catch(_ => {
            fail([]);
        });
    }

    incomingBloodAddClickHandler() {
        this.ref.modalHemo.current.open(null, ModalAction.INSERT);
    }

    incomingGridReadyHandler(params) {
        const thi = this;

        params.api.setServerSideDatasource({
            getRows: params => {
                console.log('[Datasource] - rows requested by grid: ', params.request);

                thi.updateGrid({
                    startRow: params.request.startRow,
                    endRow: params.request.endRow,
                    filterModel: params.request.filterModel
                }, params.successCallback, params.failCallback);
            }
        });

        this.setState({incomingGrid: params});
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    }
}

export default connect(mapStateToProps)(PageGridTest);